
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrazione/reset-password",
      function () {
        return require("private-next-pages/registrazione/reset-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrazione/reset-password"])
      });
    }
  